import { render, staticRenderFns } from "./Testimony.vue?vue&type=template&id=1526c1c0&scoped=true"
import script from "./Testimony.vue?vue&type=script&lang=js"
export * from "./Testimony.vue?vue&type=script&lang=js"
import style0 from "./testimony.css?vue&type=style&index=0&id=1526c1c0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1526c1c0",
  null
  
)

export default component.exports